<template>
  <FormulateInput
    v-bind="field"
    validation-behavior="live"
    class="p-0"
    :help="true"
    :value="computedValue"
    :fullObject="fullObject"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    formValues: {},
    shippedCustFullObj: {},
    isShowingData: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return this.value
    },
  },
  watch: {
    'formValues.shipped_customer_id': function () {
      this.$emit('input', this.formValues.shipped_customer_id)
      this.$emit('update:fullObject', {...this.shippedCustFullObj})
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', newValue)
    },
  },
}
</script>
